import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class MatIconSvgRegistry {

  private icons: Record<string, string> = {
    'web_traffic_v2':'/assets/icons/webTrafficV2.svg',
    'process_fork':'/assets/icons/process_fork_icon.svg'
  };

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ){
  }

  public init(): void {
    Object.entries(this.icons).forEach(([name, path]) => {
      this.matIconRegistry.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl(path));
    });
  }
}
